import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useT } from "@/i18n/I18nContext";
import { Button } from "@/components/ui/button";
import { Search } from "lucide-react";

// Mobile-only search bar shown just above "Centre de Pilotage", outside the hero.
export const MobileSearchBar = () => {
  const { t } = useT();
  const navigate = useNavigate();
  const [q, setQ] = useState("");

  const search = (e) => {
    e.preventDefault();
    navigate(`/catalogue${q ? `?q=${encodeURIComponent(q)}` : ""}`);
  };

  return (
    <div className="sm:hidden container-page pt-5" data-testid="mobile-search">
      <form onSubmit={search}
        className="flex flex-col gap-3 bg-card p-2.5 rounded-2xl shadow-md border border-border">
        <div className="relative flex-1">
          <Search className="absolute left-4 top-1/2 -translate-y-1/2 h-5 w-5 text-muted-foreground pointer-events-none" />
          <input data-testid="mobile-search-input" value={q} onChange={(e) => setQ(e.target.value)}
            placeholder={t("hero.searchPlaceholder")}
            className="w-full h-12 pl-12 pr-4 rounded-full bg-transparent outline-none text-base" />
        </div>
        <Button data-testid="mobile-search-btn" type="submit" className="h-12 rounded-full text-base bg-primary hover:bg-primary/90">
          {t("common.search")}
        </Button>
      </form>
    </div>
  );
};
